import React from 'react';
import { TimesheetsTable } from 'widgets/TimesheetsTable';

import styles from './TimesheetPage.module.scss';

const TimesheetsPage = (): React.ReactElement => {
  return (
    <div className={styles.wrapper}>
      <TimesheetsTable />
    </div>
  );
};

export default TimesheetsPage;
